module.exports = __webpack_public_path__ + "static/media/sync-primary.af4a6331.svg";